export const customIconsNPS = [
    { label: "1", fillColor: "#f8d7da" }, 
    { label: "2", fillColor: "#f8d7da" },
    { label: "3", fillColor: "#f8d7da" },
    { label: "4", fillColor: "#f8d7da" },
    { label: "5", fillColor: "#fff3cd" }, 
    { label: "6", fillColor: "#fff3cd" },
    { label: "7", fillColor: "#fff3cd" },
    { label: "8", fillColor: "#d4edda" },
    { label: "9", fillColor: "#d4edda" },
    { label: "10", fillColor: "#d4edda" },
  ];
  

  const NPSIcons = () => (
    <div style={{ display: "flex", justifyContent: "space-between", maxWidth: "600px" }}>
      {customIconsNPS?.map((item, index) => (
        <div
          key={index}
          style={{
            backgroundColor: item.fillColor,
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            color: "#000",
          }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
  
  export default NPSIcons;
  